import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Provider, { DispatchProps, OwnProps, StateProps } from './ProviderAnalyticsListScreen';

import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getProviders, getProvidersConfirmedMetrics, getProvidersCsv } from 'src/store/actions/provider-actions';
import { selectProviders } from 'src/store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: selectProviders(state),
        inProgress: state.providers.inProgress,
        inProgressCSV: state.providers.inProgressCSV,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getProvidersConfirmedMetrics(params)),
        getDataCsv: (params: QueryParams) => dispatch(getProvidersCsv(params)),
    };
}

const ProviderScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(Provider);

export default ProviderScreen;
